import React from 'react';

export const Internal = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--internal';
  color = color || '#0076CC';

  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M1.74036 17.857L12.6689 6.92847"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.59729 6.92847H12.6687V12.9999"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.69477 18.4092H15.9805C16.6246 18.4092 17.2423 18.1533 17.6977 17.6979C18.1532 17.2424 18.4091 16.6247 18.4091 15.9806V3.83775C18.4091 3.19365 18.1532 2.57594 17.6977 2.12049C17.2423 1.66505 16.6246 1.40918 15.9805 1.40918H3.83763C3.19353 1.40918 2.57582 1.66505 2.12037 2.12049C1.66492 2.57594 1.40906 3.19365 1.40906 3.83775V11.1235"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Internal;
